var cifIl = ["301 219", "<g fill='none'><path fill='#FFF' d='M.5.409h300v218.182H.5z'/><path fill='#0038B8' d='M.5 20.863h300v34.091H.5zM.5 164.045h300v34.091H.5z'/><path stroke='#0038B8' stroke-width='6.364' d='M150.5 149.237l34.414-59.606h-68.828z'/><path stroke='#0038B8' stroke-width='6.364' d='M150.5 69.762l-34.414 59.607h68.828z'/></g>"];

export { cifIl };

